// 普通api
import Axios from './axios'
const path = JSON.parse(localStorage.getItem('userBase')) ? JSON.parse(localStorage.getItem('userBase'))?.[0]?.user?.path : '';
function getStartStr(){
  return JSON.parse(localStorage.getItem('userBase')).path
}
function getUserId(){
  return JSON.parse(localStorage.getItem('userBase')).id
}
export default {
  addPostHeader(config) {
    return {
      ...config,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' }
    }
  },
  getCaptcha() {
    return Axios.get("/captcha/")
  },
  //登录接口
  login(params) {
    return Axios.post("/login", params)
  },
  //公司编码登录
  step_login(params) {
    return Axios.post("/tenant", params)
  },
}

